import type { ReactNode, MouseEvent } from 'react';
import { twMerge } from 'tailwind-merge';
import { isBlank } from '@witmetrics/utils/strings';
import InfoPoint from '@/components/InfoPoint';
import TruncatedText from '@/components/TruncatedText';
import { classes } from './utils';

export type ParameterCardProps = {
  label: string;
  description?: string;
  selected?: boolean;
  interactive?: boolean;
  className?: string;
  bodyClassName?: string;
  headerStartAdornment?: ReactNode;
  children: ReactNode;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
};

export default function ParameterCard({
  label,
  description,
  selected = false,
  interactive = false,
  className,
  bodyClassName,
  headerStartAdornment,
  children,
  onClick,
}: ParameterCardProps) {
  return (
    <div
      className={twMerge(
        classes.card,
        selected ? classes.cardSelected : classes.cardDefault,
        interactive && classes.cardInteractive,
        className
      )}
      onClick={onClick}>
      <div className={classes.header}>
        {headerStartAdornment}
        <TruncatedText
          className={classes.label}
          textClassName={classes.labelText}
          tooltipPlacement="top">
          {label}
        </TruncatedText>
      </div>
      {!isBlank(description) && (
        <InfoPoint className={classes.infoPoint} content={description!} />
      )}
      <div className={twMerge(classes.body, bodyClassName)}>{children}</div>
    </div>
  );
}
